import { StyleSheet } from 'react-native';
import { blues, colors, fontSizes, globalMargin } from '@rivallapp/volosports-components';

export default StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginHorizontal: 10,
    marginBottom: 8,
  },

  headerTitle: {
    fontWeight: 'bold',
    fontSize: fontSizes.large,
    color: colors.brandPrimary,
  },

  link: {
    color: blues.medium,
    fontSize: fontSizes.extraSmall,
    textDecorationLine: 'underline',
    padding: 4,
    marginHorizontal: globalMargin,
  },
});
